export default "__VITE_ASSET__CBNN6qzB__"